export default __webpack_public_path__ + "static/media/wave.a3c8e695.svg";